import { VALID_FILTER_FOR_SUMMARY } from "modules/category/constants/filter-constants";

export function filterRenderKeys(appliedFilters: any, validNbcFilters) {
  const appliedFiltersKeys = Object.keys(appliedFilters || {});
  return appliedFiltersKeys
    .sort()
    .filter((filterKey) => {
      // don't display when have all 3 keys make model year
      // if (appliedFiltersKeys.every((i) => ["make", "model", "year"].includes(i))) {
      //   return false;
      // }
      if ((VALID_FILTER_FOR_SUMMARY.includes(filterKey) || validNbcFilters?.includes(filterKey))
           && appliedFilters[filterKey]) {
        return true;
      }
      return false;
    });
}
